import { lazy } from "react";

export { REQUESTS_PATH } from "./requests-page-path";
export const RequestsPage = lazy(() => import("./requests-page"));
